<template>
  <div class="form-list">
    <el-form
      class="form form-medium"
      ref="form"
      :rules="rules"
      :model="postData"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="所属学员">
        <v-avatar-nickname :value="invoice.selfie" :nickname="invoice.student_name"/>
      </el-form-item>

      <el-form-item label="申请人">
        <v-avatar-nickname :value="invoice.admin_avatar" :nickname="invoice.admin_nickname"/>
      </el-form-item>

      <el-form-item label="申请门店">
        {{ invoice.store_name }}
      </el-form-item>

      <el-form-item label="发票类型">
        {{ invoice.is_other ? '其他' : '课卡' }}
      </el-form-item>

      <el-form-item v-if="invoice.is_other" label="类型名称">
        {{ invoice.other_name }}
      </el-form-item>

      <el-form-item v-else label="所属课卡">
        No.{{ invoice.card_id }}
      </el-form-item>

      <el-form-item label="开票金额">
        {{ invoice.amount | toYuan }} 元
      </el-form-item>

      <el-form-item label="发票对象">
        {{ invoice.is_personal ? '个人' : '公司' }}
      </el-form-item>

      <el-form-item label="名称">
        {{ invoice.invoice_name }}
      </el-form-item>

      <el-form-item v-if="!invoice.is_personal" label="纳税人识别号">
        {{ invoice.taxpayer_id }}
      </el-form-item>

      <el-form-item label="地址、电话">
        {{ invoice.address }}
      </el-form-item>

      <el-form-item v-if="!invoice.is_personal" label="开户行及账号">
        {{ invoice.bank_account }}
      </el-form-item>

      <el-form-item label="发票类目">
        {{ invoice.invoice_class_name }}
      </el-form-item>

      <el-form-item label="税额">
        {{ invoice.amount | toYuan }}×{{ invoice.tax_rate | toYuan }}%={{ invoice.tax_amount | toYuan }}
      </el-form-item>

      <el-form-item label="开票方式">
        {{ invoice.is_paper ? '纸质' : '电子' }}发票
      </el-form-item>

      <template v-if="invoice.is_paper">
        <el-form-item label="收件人">
          {{ invoice.paper_name }}
        </el-form-item>
        <el-form-item label="收件地址">
          {{ invoice.paper_address }}
        </el-form-item>
        <el-form-item label="收件人电话">
          {{ invoice.phone }}
        </el-form-item>
      </template>

      <el-form-item v-else label="电子邮箱">
        {{ invoice.email }}
      </el-form-item>

      <template v-if="isAdministrator && invoice.state === invoiceStates.review.value">
        <el-form-item label="审核结果">
          <el-radio v-model="postData.state" :label="invoiceStates.passed.value">通过</el-radio>
          <el-radio v-model="postData.state" :label="invoiceStates.rejected.value">驳回</el-radio>
        </el-form-item>
        <template v-if="postData.state === invoiceStates.passed.value">
          <el-form-item v-if="invoice.is_paper" label="快递单号" prop="courier_number">
            <el-input
              class="clearable-word-limit-input"
              v-model="postData.courier_number"
              maxlength="144"
              placeholder="请输入快递单号"
              show-word-limit
              clearable
            />
          </el-form-item>
          <v-image-upload
            v-else
            v-model="postData.invoice_url"
            accept=".pdf"
            ratio="1:1"
            label="电子发票文件"
            prefix="invoice"
            prop-name="invoice_url"
          />
        </template>

        <el-form-item v-if="postData.state === invoiceStates.rejected.value" label="驳回原因" prop="reject_reason">
          <el-input
            class="clearable-word-limit-input"
            v-model="postData.reject_reason"
            maxlength="128"
            placeholder="请输入驳回原因"
            show-word-limit
            clearable
          />
        </el-form-item>
      </template>

      <el-form-item v-if="isManagerOrReceptionist || (isAdministrator && invoice.state !== invoiceStates.review.value)" label="开票进度">
        <el-tag v-for="state in findInvoiceState(invoice.state)" :key="state.value" :type="state.tagType">{{ state.name }}</el-tag>
      </el-form-item>

      <template v-if="invoice.state === invoiceStates.passed.value">
        <el-form-item v-if="invoice.is_paper" label="快递单号">
          {{ invoice.courier_number }}
        </el-form-item>
        <el-form-item v-else label="电子发票文件">
          <a class="primary-color" :href="invoice.invoice_url" target="_blank">{{invoice.invoice_url}}</a>
        </el-form-item>
      </template>

      <el-form-item v-if="invoice.state === invoiceStates.rejected.value" label="驳回原因">
        {{ invoice.reject_reason }}
      </el-form-item>

      <el-form-item>
        <el-button v-if="isAdministrator && invoice.state === invoiceStates.review.value" type="primary" @click="handleExamine" :loading="isSaving">完成审核</el-button>
        <el-button
          v-if="isManagerOrReceptionist && userStoreId === invoice.store_id && invoice.state === invoiceStates.review.value"
          type="primary"
          @click="handleRevoke"
          :loading="isSaving"
        >
          撤销申请
        </el-button>
        <el-button @click="RouteConfig.invoiceList.back">返回</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { invoiceStates, findInvoiceState } from '@/enums/invoiceStates';
import { mapGetters } from 'vuex';
import { show, examine, revoke } from '@/api/invoice';

export default {
  name: RouteConfig.invoiceDetail.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    invoice: {
      id: 0,
      add_time: 0,
      store_id: 0,
      student_id: 0,
      is_other: 0,
      other_name: '',
      card_id: 0,
      amount: 0,
      is_personal: 0,
      invoice_name: '',
      taxpayer_id: '',
      address: '',
      bank_account: '',
      invoice_class_id: 0,
      tax_rate: 0,
      tax_amount: 0,
      is_paper: 0,
      paper_name: '',
      paper_address: '',
      phone: '',
      email: '',
      state: 0,
      admin_id: 0,
      admin_nickname: '',
      admin_avatar: '',
      store_name: '',
      student_name: '',
      selfie: '',
      invoice_class_name: '',
      courier_number: '',
      reject_reason: '',
      invoice_url: '',
    },
    postData: {
      courier_number: '',
      reject_reason: '',
      state: invoiceStates.passed.value,
    },
    rules: {
      courier_number: [{required: true, message: '请输入快递单号', trigger: 'change'}],
      reject_reason: [{required: true, message: '请输入驳回原因', trigger: 'change'}],
    },
    findInvoiceState,
    invoiceStates,
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
    ...mapGetters([
      'isAdministrator',
      'isManagerOrReceptionist',
      'userStoreId',
    ]),
  },
  methods: {
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { invoice } = this;
      const tempObject = {};
      Object.keys(data).forEach(key => {
        if (key in invoice) tempObject[key] = data[key];
      });
      Object.assign(invoice, tempObject);
    },
    handleExamine() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;

        const postData = { ...this.postData };
        postData.is_paper = this.invoice.is_paper;
        const { isError } = await examine(this.id, postData);
        this.isSaving = false;
        if (!isError) RouteConfig.invoiceList.push();
      });
    },
    handleRevoke() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const { isError } = await revoke(this.id);
        this.isSaving = false;
        if (!isError) RouteConfig.invoiceList.push();
      });
    },
  },
  beforeMount() {
    this.show();
  },
};
</script>
